import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={22} height={22} fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.938 13.306a.344.344 0 00.487 0L15.55 9.18a.344.344 0 00-.487-.487l-3.881 3.882L7.3 8.694a.344.344 0 00-.487.487l4.125 4.125z" fill="#000" stroke="#6F6F6F" strokeWidth={0.688} /></svg>;
}
export default SvgComponent;